// Copyright (c) 2015 Steven Sojka
/* eslint-disable */
export function isPrototypeAccess(context: object, target: object): boolean {
  // @ts-expect-error
  const obj = this ?? {};
  return (
    context === target || (context.constructor !== target.constructor && Object.getPrototypeOf(obj).constructor === target.constructor)
  );
}
